const initShareButtons = async (buttons) => {

    const showToast = (message, el, button) => {
        el.textContent = message;
        el.classList.add('is-active');

        setTimeout(() => {
            el.classList.remove('is-active');
            button.classList.remove('is-active');
        }, 2000);
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const url = window.location.href;
            const toastEl = button.querySelector('.js-toast');
            if (!button.classList.contains('is-active')) {
                button.classList.add('is-active');
                var dummy = document.createElement('input'),
                    text = window.location.href;
                    document.body.appendChild(dummy);
                    dummy.value = text;
                    dummy.select();
                    document.execCommand('copy');
                    document.body.removeChild(dummy);
                    showToast('URL Copied', toastEl, button);
            }
        })
    })

}

export default initShareButtons;